import canUseDOM from './canUseDOM'

export const getServerSideURL = () => {
  // SITE_URL is a runtime-only env var not inlined by Next.js at build time,
  // making it work correctly in Docker deployments where NEXT_PUBLIC_SERVER_URL
  // gets baked in as undefined during image build.
  let url = process.env.SITE_URL || process.env.NEXT_PUBLIC_SERVER_URL

  if (!url && process.env.VERCEL_PROJECT_PRODUCTION_URL) {
    return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
  }

  if (!url) {
    url = 'http://localhost:3000'
  }

  return url
}

// The canonical production hostnames. Prod and dev run the exact same
// image/container — there's no build-time distinction between them — so
// this is checked per-request against the incoming Host header, not against
// any baked-in env var. Any request whose Host isn't one of these (dev, a
// preview URL, localhost, a future staging env, etc.) is treated as
// non-production and gets noindex'd — fail safe, not fail open.
const PRODUCTION_HOSTNAMES = new Set(['outsnapped.com', 'www.outsnapped.com'])

export const isProductionHostname = (host: string | null | undefined): boolean => {
  if (!host) return false
  const hostname = host.split(':')[0]?.toLowerCase()
  return Boolean(hostname && PRODUCTION_HOSTNAMES.has(hostname))
}

export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol
    const domain = window.location.hostname
    const port = window.location.port

    return `${protocol}//${domain}${port ? `:${port}` : ''}`
  }

  if (process.env.VERCEL_PROJECT_PRODUCTION_URL) {
    return `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
  }

  return process.env.NEXT_PUBLIC_SERVER_URL || ''
}
